// extracted by mini-css-extract-plugin
export var icon = "_9u-3";
export var subtitle = "_9u-2";
export var title = "_9u-1";
export var value = "_9u-0";